import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltung-prueflauf-status';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksVeranstaltungPrueflaufStatusEffects {

    VeranstaltungPrueflaufStatus$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_PRUEFLAUF_STATUS),
        mergeMap((x: ac.GetVeranstaltungPrueflaufStatusAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungPrueflaufStatus(x.prueflaufStatusRequest).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungPrueflaufStatusErfolgreichAction(result, x.prueflaufStatusRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungPrueflaufStatusFehlerAction(error, x.prueflaufStatusRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.PrueflaufQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.PrueflaufQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.PrueflaufQueryService);
        }
        return this.service;
    }
}
